


















import { Component, Vue, Watch } from "vue-property-decorator";
import { IndexedDbStore } from "./indexedDb";

@Component({})
export default class App extends Vue {
  private showScreenSaver = false;
  private videoInterval = 60000;
  private videoUrl = "";
  private timer = -1;
  private webViewerUrl =
    "https://cdn.flipsnack.com/widget/v2/widget.html?hash=tj56npprzp";
  private videoSrc = "";
  private store!: IndexedDbStore;

  constructor() {
    super();
    const params = new URLSearchParams(window.location.search.slice(1));
    if (params.has("videoInterval")) {
      this.videoInterval =
        parseInt(params.get("videoInterval") || "") * 1000 || 60000;
    }
    if (params.has("webViewerUrl")) {
      this.webViewerUrl = params.get("webViewerUrl") || "";
    }
    if (params.has("videoUrl")) {
      this.videoUrl = params.get("videoUrl") || "";
      this.videoSrc = this.videoUrl;

      // const key = encodeURIComponent(this.videoUrl);
      // this.store = new IndexedDbStore("videos");
      // this.store.open("assets-cache", 1).then(() => {
      //   this.store.has(key).then(async (has: boolean) => {
      //     if (has) {
      //       // Video je již předcachovane
      //       this.setCachedVideo(key);
      //       return;
      //     }

      //     // Prvně odstraním uložená videa z IndexedDB
      //     const urls = await this.store.getAllKeys();
      //     await Promise.all(
      //       urls.map(async encodedUrl => {
      //         const key = encodedUrl;
      //         await this.store.delete(key);
      //         return key;
      //       })
      //     );

      //     // Video musi byt prvne stazeno
      //     this.fetchVideo(this.videoUrl).then((blob: Blob) => {
      //       this.store.put(key, blob).then(() => {
      //         this.setCachedVideo(key);
      //       });
      //     });
      //   });
      // });
    }
    setInterval(this.checkFocus, 2000);
  }

  mounted() {
    const web = document.querySelector("#web-viewer") as HTMLIFrameElement;
    web.src = this.webViewerUrl;

    window.addEventListener("mousedown", this.hideScreenSaver, {
      passive: false
    });
    window.addEventListener("touchstart", this.hideScreenSaver, {
      passive: false
    });
  }

  private fetchVideo(url: string): Promise<Blob> {
    return fetch(url).then(response => response.blob());
  }

  private setCachedVideo(key: string) {
    this.store.get(key).then((blob: Blob) => {
      const url = URL.createObjectURL(blob);
      this.videoSrc = url;
    });
  }

  destroyed() {
    window.removeEventListener("mousedown", this.hideScreenSaver);
    URL.revokeObjectURL(this.videoSrc);
  }

  private userInactivity = false;

  private checkFocus() {
    // Pokud je zobrazeny screen saver nebo video neni stazene, tak nekontroluj focus
    if (this.showScreenSaver || !this.videoSrc) {
      return;
    }

    // Kontrola jestli ma iframe focus, pokud ano tak ho zavolam blur, zrusim casoc (v pri zmene userInactivity). Jinak nastavim userInactivity na true a spustim casovac.
    if (document.activeElement == document.querySelector("#web-viewer")) {
      this.userInactivity = false;
      const d = document.activeElement as HTMLElement;
      d.blur();
    } else {
      this.userInactivity = true;
    }
  }

  @Watch("userInactivity")
  onUserInactivityChanged(value: boolean) {
    if (value === false) {
      clearTimeout(this.timer);
    } else {
      this.timer = setTimeout(this.showScreensaver, this.videoInterval);
    }
  }

  private showScreensaver() {
    const video = document.querySelector("#video") as HTMLVideoElement;
    video.play().then(() => {
      this.showScreenSaver = true;
      const web = document.querySelector("#web-viewer") as HTMLIFrameElement;
      web.src = "about:blank";
      setTimeout(() => {
        // eslint-disable-next-line no-self-assign
        web.src = this.webViewerUrl;
      }, 1000);
    });
  }

  private hideScreenSaver(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.showScreenSaver = false;
    const video = document.querySelector("#video") as HTMLVideoElement;
    video.pause();
    this.userInactivity = false;
  }
}
